import React from 'react';
import './GameControls.css';

const GameControls = ({ currentPlayer, removedCells, initialRemovalInProgress }) => {
  return (
    <div className="game-controls">
      <div className="player-info">
        <div className={`player ${currentPlayer === 1 && !initialRemovalInProgress ? 'active' : ''}`}>
          <div className="player-icon">1</div>
          <div className="player-name">プレイヤー 1</div>
        </div>
        <div className={`player ${currentPlayer === 2 && !initialRemovalInProgress ? 'active' : ''}`}>
          <div className="player-icon">2</div>
          <div className="player-name">プレイヤー 2</div>
        </div>
      </div>
      <div className="game-stats">
        <p>消去したマス: <span className="stat-value">{removedCells}</span></p>
      </div>
      <div className="turn-info">
        {initialRemovalInProgress ? (
          <div className="initial-removal-info">
            <p>初期設定中...</p>
            <p className="instruction">マスを自動的に消去しています</p>
          </div>
        ) : (
          <>
            <p>プレイヤー {currentPlayer} の番です</p>
            <p className="instruction">数字を1つ消してください</p>
          </>
        )}
      </div>
    </div>
  );
};

export default GameControls;
